import { render, staticRenderFns } from "./batchDelOrder.vue?vue&type=template&id=77ca85a2&scoped=true"
import script from "./batchDelOrder.vue?vue&type=script&lang=js"
export * from "./batchDelOrder.vue?vue&type=script&lang=js"
import style0 from "./batchDelOrder.vue?vue&type=style&index=0&id=77ca85a2&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77ca85a2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('77ca85a2')) {
      api.createRecord('77ca85a2', component.options)
    } else {
      api.reload('77ca85a2', component.options)
    }
    module.hot.accept("./batchDelOrder.vue?vue&type=template&id=77ca85a2&scoped=true", function () {
      api.rerender('77ca85a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/finance/receivableManagementSite/aRGenerationNew/cmp/batchDelOrder.vue"
export default component.exports